__turbopack_context__.v({
  "chaseSpin": "chase-light-button-module__DvfR4W__chaseSpin",
  "inner": "chase-light-button-module__DvfR4W__inner",
  "wrapper": "chase-light-button-module__DvfR4W__wrapper",
});
